import { useDialog, lt } from '@mews/framework';
import { DropDownButton, IconName, DropdownItem, Icon, IconButton, Stack } from '@optimus-web/core';
import { DeleteDialog } from '../../../common/DeleteDialog';

export const ActionCell = () => {
    const [{ onClose: onDeleteDialogClose, active: isDeleteDialogActive }, openDeleteDialog] = useDialog();
    const handleGuestProfileDelete = () => {
        onDeleteDialogClose();
    };
    return (
        <>
            <Stack itemAlignment="center">
                <IconButton variant="ghost" icon={IconName.ReservationOverview} type="button" />
                <DropDownButton icon={IconName.More} size="small" variant="ghost">
                    <DropdownItem
                        label={lt('ViewDetails')}
                        leftDetail={<Icon value={IconName.Info} size="small" />}
                        onClick={() => {}}
                    />
                    <DropdownItem
                        label={lt('Edit')}
                        leftDetail={<Icon value={IconName.Edit} size="small" />}
                        onClick={() => {}}
                    />
                    <DropdownItem
                        label={lt('Delete')}
                        leftDetail={<Icon value={IconName.Delete} size="small" />}
                        onClick={openDeleteDialog}
                    />
                </DropDownButton>
            </Stack>
            <DeleteDialog
                isActive={isDeleteDialogActive}
                onClose={onDeleteDialogClose}
                title={lt('ContractGuestProfileDeleteConfirmationTitle')}
                description={lt('ContractGuestProfileDeleteConfirmationDescription')}
                onDelete={handleGuestProfileDelete}
            />
        </>
    );
};
